module.exports = __webpack_public_path__ + "img/ft-icon1.fb266cdc.png";